export default __webpack_public_path__ + "static/media/product-img.850d1419.png";